import { queryClient } from "../query-client";
import { queryKeys } from "../query-keys";
import { crmApi } from "../api";
import { getCachedProId, STALE_2MIN, STALE_5MIN } from "./shared";

export function prefetchCrmKanban() {
	const proId = getCachedProId();
	if (!proId) return;
	queryClient.ensureQueryData({
		queryKey: queryKeys.crm.kanban(proId),
		queryFn: () =>
			crmApi
				.getKanbanData(proId)
				.then((r) => r.data || { stages: [], leads: [] }),
		staleTime: STALE_2MIN,
	});
	queryClient.ensureQueryData({
		queryKey: queryKeys.crm.stages(proId),
		queryFn: () => crmApi.getStages(proId).then((r) => r.data || []),
		staleTime: STALE_5MIN,
	});
}

export function prefetchCrmLeadDetail(leadId: string) {
	const proId = getCachedProId();
	if (!proId) return;
	queryClient.ensureQueryData({
		queryKey: queryKeys.crm.lead(proId, leadId),
		queryFn: () =>
			crmApi.getLead(proId, Number(leadId)).then((r) => r.data),
		staleTime: STALE_2MIN,
	});
	queryClient.ensureQueryData({
		queryKey: queryKeys.crm.activities(proId, leadId),
		queryFn: () =>
			crmApi
				.getActivities(proId, Number(leadId))
				.then((r) => r.data || { activities: [], total: 0 }),
		staleTime: 1000 * 60,
	});
}

export function prefetchCrmAnalytics() {
	const proId = getCachedProId();
	if (!proId) return;
	queryClient.ensureQueryData({
		queryKey: queryKeys.crm.analytics(proId, "this_month"),
		queryFn: () => crmApi.getDashboard(proId).then((r) => r.data),
		staleTime: STALE_2MIN,
	});
}

export function prefetchCrmSettings() {
	const proId = getCachedProId();
	if (!proId) return;
	queryClient.ensureQueryData({
		queryKey: queryKeys.crm.settings(proId),
		queryFn: () => crmApi.getSettings(proId).then((r) => r.data),
		staleTime: STALE_5MIN,
	});
	queryClient.ensureQueryData({
		queryKey: queryKeys.crm.stages(proId),
		queryFn: () => crmApi.getStages(proId).then((r) => r.data || []),
		staleTime: STALE_5MIN,
	});
	queryClient.ensureQueryData({
		queryKey: queryKeys.crm.sources(proId),
		queryFn: () => crmApi.getSources(proId).then((r) => r.data || []),
		staleTime: STALE_5MIN,
	});
}
